<template>
    <div class="yachts_book">
        <h3>{{ $t('yachts_book_title') }}</h3>
        <div class="yachts_book_main">
            <div class="yachts_list_wrapper">
                <el-carousel class="bookImg" trigger="click" :autoplay="false">
                    <el-carousel-item v-for="(item, indexs) in books.media" :key="indexs">
                        <img :src="item.mediaUrl" alt="" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="book_from_only">
                <p>{{ $t('yachts_lists_title') }}</p>
                <p class="price">AED {{ books.yachtsPrice }}</p>
            </div>
            <p class="book_name">{{ books.productName.toUpperCase() }}</p>
            <div class="book_text">
                <div class="book_address">
                    <p>{{ $t('length') }}</p>
                    <span>{{ books.length }} {{ $t('ft') }}</span>
                </div>
                <div class="book_capacity">
                    <p>{{ $t('capacity') }}</p>
                    <span>{{ $t('upTo') }} {{ books.maxPassenger }} {{ $t('pax') }}</span>
                </div>
                <div class="book_crew">
                    <p>{{ $t('crew') }}</p>
                    <span>{{ books.crewNum }}+{{ books.captainNum }}</span>
                </div>
            </div>
            <el-form class="book_form" ref="dataForm" :model="temp" label-position="right" @submit.native.prevent>
                <el-form-item :label="this.$t('Name')">
                    <el-input v-model="temp.name"></el-input>
                </el-form-item>
                <el-form-item :label="this.$t('Phone')" class="book_form_mobile">
                    <el-select
                        v-model="temp.code"
                        placeholder=""
                        :popper-append-to-body="false"
                        popper-class="booking_code"
                    >
                        <el-option
                            v-for="(item, i) in areaCode"
                            :key="i"
                            :value="item.phone_code"
                            :label="' +' + item.phone_code"
                            >{{ $i18n.locale == 'chinese' ? item.chinese_name : item.english_name }} +{{
                                item.phone_code
                            }}</el-option
                        >
                    </el-select>
                    <el-input class="booking_mobile" v-model="temp.phone"></el-input>
                </el-form-item>
                <el-form-item :label="this.$t('e_mail')">
                    <el-input v-model="temp.email"></el-input>
                </el-form-item>
                <el-form-item :label="this.$t('Guests')" class="book_form_guests">
                    <el-input v-model="temp.adult" class="book_form_adult"></el-input>
                    <el-input v-model="temp.child" class="book_form_child"></el-input>
                </el-form-item>
            </el-form>
            <el-button class="book_proceed" @click="proceed_submit">{{ $t('proceed') }}</el-button>
        </div>
    </div>
</template>

<script>
import AreaCode from '@/utils/phone.json'
import { check_Mail, check_Number, checkAllNull, SortAreaCode } from '@/libs/form'
export default {
    props: ['books'],
    data() {
        return {
            temp: {
                name: '',
                phone: '',
                email: '',
                adult: '',
                child: '',
                code: '',
            },
            areaCode: AreaCode.sort(SortAreaCode),
        }
    },
    created() {},
    methods: {
        proceed_submit() {
            let { name, phone, email, adult, child, code } = this.temp
            // 验证用户名
            if (name == '' || name.length > 64) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.nameCheck'),
                })
            }
            // 验证手机号码
            if (
                phone == '' ||
                phone.length + code.length > 20 ||
                phone.length + code.length < 6 ||
                !check_Number(phone)
            ) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.phoneCheck'),
                })
            }
            if (code == '' || !check_Number(code)) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.qzCheck'),
                })
            }
            if (!check_Mail(email) || !checkAllNull(email)) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.emailCheck'),
                })
            }
            if (!check_Number(adult) || !checkAllNull(adult)) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.adultsCheck'),
                })
            }
            if (!check_Number(child)) {
                if (child) {
                    return this.$message({
                        type: 'warning',
                        message: this.$t('form.childrenCheck'),
                    })
                } else {
                    this.temp.child = 0
                }
            }
            if (+adult + +child > +this.books.maxPassenger) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.peoplesCheck'),
                })
            }
            if (adult == 0) {
                return this.$message({
                    type: 'warning',
                    message: this.$t('form.mustAdultCheck'),
                })
            }
            this.$emit('proceed_sub', this.temp)
        },
    },
}
</script>
<style scoped src="@/styles/super.css"></style>
<style lang="less">
.bookImg {
    height: 240px;
    .el-carousel__container {
        height: 100%;
    }
    img {
        width: 100%;
        height: 240px;
    }
}
.book_form .el-form-item__content {
    display: flex;
}
.el-select .el-input__inner {
    width: 88px;
    padding: 0 10px;
    /* prettier-ignore */
    min-width: 85PX;
}
.book_form_mobile .booking_code input {
    width: 90px;
}
.book_form_mobile .booking_mobile {
    // width: 180px;
    flex: 1;
}
.book_form_mobile .booking_mobile input {
    // width: 180px !important;
    width: 100%;
    margin-left: 7px;
}
.booking_code {
    width: 285px !important;
}
.el-select {
    .el-input__suffix {
        display: flex;
        align-items: center;
        .el-input__icon {
            height: 150%;
        }
    }
}

.book_form_guests {
    .book_form_adult {
        width: 134px;
        margin-right: 7px;
        input {
            width: 134px;
        }
    }
    .book_form_child {
        // width: 134px;
        flex: 1;
        input {
            // width: 134px;
            width: 100%;
        }
    }
}
.yachts_book {
    width: 466px;
    /* prettier-ignore */
    min-width: 350PX;
    height: 655px;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
    h3 {
        width: 100%;
        height: 61px;
        font-size: 25px;
        font-weight: 600;
        line-height: 51px;
        text-align: center;
        border: 5px solid #fff;
        box-sizing: border-box;
        color: #020b3b;
        background: #ffcc69;
        margin: 0;
    }
}
.yachts_book_main {
    position: relative;
    width: 100%;
    height: 594px;
    padding: 20px 15px 21px 16px;
    box-sizing: border-box;
    background: #020b3b;
    .book_from_only {
        position: absolute;
        top: 26px;
        right: 15px;
        z-index: 857;
        width: 134px;
        height: 56px;
        background-color: #ffcc69;
        text-align: center;
        padding-top: 7px;
        color: #000;
        font-family: 'Lato';
        p {
            font-size: 16px;
        }
        .price {
            font-weight: 700;
            font-size: 18px;
        }
    }
    .yachts_list_wrapper {
        // width: 435px;
        width: 100%;
        height: 240px;
        background: #ffffff;
        border-radius: 0px;
    }
}
.book_name {
    width: 100%;
    height: 32px;
    background: #ffcc69;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    color: #020b3b;
    font-family: Lato Bold;
}
.book_text {
    display: flex;
    margin-bottom: 2px;
    font-family: Lato Bold;
    & > div {
        flex: 1;
    }
}
.book_text div {
    height: 45px;
    /* prettier-ignore */
    min-height: 35PX;
    background: #ffcc69;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    color: #020b3b;
}
.book_text div p {
    margin-top: 3px;
    height: 20px;
}
.book_text div span {
    height: 20px;
    display: block;
}
.book_address {
    // width: 146px;
    border: 1px solid #ffffff;
}
.book_capacity {
    // width: 145px;
    border-top: 1px solid #ffffff;
    border-bottom: 1px solid #ffffff;
}
.book_crew {
    // width: 146px;
    border: 1px solid #ffffff;
}
.yachts_book_main .el-form {
    font-family: Lato Bold Italic;
    width: 100%;
}
.book_form .el-form-item {
    margin-top: 9px;
    margin-bottom: 0;
    overflow: hidden;
}
.book_form .el-form-item__label {
    height: 27px;
    line-height: 27px;
    background: #ffcc69;
    font-size: 20px;
    font-weight: normal;
    text-align: right;
    color: #020b3b;
    width: 150px;
}

.book_form .el-form-item__content {
    line-height: 27px;
}
.book_form .el-input {
    height: 27px;
    display: flex;
}
.book_form input {
    width: 275px;
    height: 27px;
    margin-left: 10px;
    background: #ffffff;
    border-radius: 0px;
}
.yachts_book_main .book_proceed {
    // width: 435px;
    width: 100%;
    height: 46px;
    background: #ffcc69;
    margin-top: 44px;
    font-size: 20px;
    font-family: Lato-Bold, Lato;
    font-weight: bold;
    color: #020b3b;
    border: none;
    border-radius: 0;
}
.yachts_book_main .el-button:focus,
.yachts_book_main .el-button:hover {
    color: #020b3b !important;
    background: #ffda69 !important;
}
.el-input {
    input {
        width: 100%;
    }
}
</style>
